import React, { FunctionComponent, useState } from "react";
import { useCart } from "../../../../../context/CartContext";
// Components
import CartDetailedSectionHeaderComponent from "./CartDetailSection/CartDetailedSectionHeader";
import CartDetailedItem from "./CartDetailSection/CartDetailedItem";
import EditItemModal from "./CartDetailSection/EditItemModal";
import { DetailedCartItem } from "../../../../../context/CartContext/CartContext.api.types";
import { ProductServices } from "../../../../../services/products";
import useModal from "../../../../../utils/hooks/useModal";
import { clearAllBodyScrollLocks } from "body-scroll-lock";
import RemoveItemModal from "./CartDetailSection/RemoveItemModal";

type Props = {};

const CartDetailComponent: FunctionComponent<Props> = () => {
  const { cart } = useCart();

  const { isOpen, toggle } = useModal();
  const [modalDetailedItem, setModalDetailedItem] =
    useState<DetailedCartItem | null>(null);

  const [modalType, setModalType] = useState<
    "edit" | "delete" | "clear" | null
  >(null);

  const handlePreEdit = (detailedItem: DetailedCartItem) => {
    setModalType("edit");
    setModalDetailedItem(detailedItem);
    toggle();
  };

  const handlePreDelete = (detailedItem: DetailedCartItem) => {
    setModalType("delete");
    setModalDetailedItem(detailedItem);
    toggle();
  };

  const handleCloseModal = () => {
    clearAllBodyScrollLocks();
    toggle();
  };

  const getLabels = (cartDetailedItem: DetailedCartItem) => {
    return ProductServices.getProductsLabels(
      cartDetailedItem.product.category
        ? cartDetailedItem.product.category
        : "",
      cartDetailedItem.product.department
        ? cartDetailedItem.product.department
        : "",
      cartDetailedItem.product.isCustom
        ? cartDetailedItem.product.isCustom
        : false
    );
  };

  return (
    <>
      {modalDetailedItem && modalType === "edit" && (
        <EditItemModal
          isOpen={isOpen}
          onClose={handleCloseModal}
          cartDetailedItem={modalDetailedItem}
          getLabels={getLabels}
        />
      )}
      {modalDetailedItem && modalType === "delete" && (
        <RemoveItemModal
          isOpen={isOpen}
          onClose={handleCloseModal}
          cartDetailedItem={modalDetailedItem}
        />
      )}
      {cart?.detailed?.gold?.variations?.length &&
      cart.detailed.gold.variations.length > 0 ? (
        <>
          <CartDetailedSectionHeaderComponent>
            ORO
          </CartDetailedSectionHeaderComponent>
          {cart.detailed.gold.variations.map((cartDetailedItem) => (
            <CartDetailedItem
              key={cartDetailedItem.variation.id}
              cartDetailedItem={cartDetailedItem}
              onEdit={handlePreEdit}
              onDelete={handlePreDelete}
              getLabels={getLabels}
            />
          ))}
        </>
      ) : null}

      {cart?.detailed?.silver?.variations?.length &&
      cart.detailed.silver.variations.length > 0 ? (
        <>
          <CartDetailedSectionHeaderComponent>
            PLATA
          </CartDetailedSectionHeaderComponent>
          {cart.detailed.silver.variations.map((cartDetailedItem) => (
            <CartDetailedItem
              key={cartDetailedItem.variation.id}
              cartDetailedItem={cartDetailedItem}
              onEdit={handlePreEdit}
              onDelete={handlePreDelete}
              getLabels={getLabels}
            />
          ))}
        </>
      ) : null}
    </>
  );
};

export default CartDetailComponent;
